import { api_POST } from "../api/_axios.js";

const impressaodocumento_api = {
    postHashRelatorio: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`impressaodocumento/PostHashRelatorio`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default impressaodocumento_api;
